import { render, staticRenderFns } from "./StatusChangeBar.vue?vue&type=template&id=2377931c&scoped=true&"
import script from "./StatusChangeBar.vue?vue&type=script&lang=js&"
export * from "./StatusChangeBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusChangeBar.vue?vue&type=style&index=0&id=2377931c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2377931c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2377931c')) {
      api.createRecord('2377931c', component.options)
    } else {
      api.reload('2377931c', component.options)
    }
    module.hot.accept("./StatusChangeBar.vue?vue&type=template&id=2377931c&scoped=true&", function () {
      api.rerender('2377931c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoods/components/StatusChangeBar.vue"
export default component.exports